// All trial / access-state wording lives here so it can be reviewed and changed in one place.
// DRAFT: wording from plan section 6.2 and Zee's approved lines ("30-day free trial", "No card required").
// Do not say "credit card": say "card".

export const TRIAL_COPY = {
  trialName: "30-day free trial",
  noCard: "No card required",

  // trial banner
  trialDaysLeft: (n) => (n === 1 ? "1 day left" : `${n} days left`),
  trialBannerLead: "30-day free trial",
  trialBannerNote: "No card required. Add a card only when you choose a plan.",
  trialBannerNonOwner: "Ask your account owner to choose a plan before the trial ends.",
  choosePlan: "Choose a plan",
  onboardingLink: "Book free setup help",

  // read-only
  readOnlyTitle: "Your free trial has ended. Your account is read-only.",
  readOnlyUntil: (date) => `You can view everything until ${date}, then the account is locked. Choose a plan to keep adding and editing.`,
  readOnlyNonOwner: "Ask your account owner to choose a plan.",

  // lock screen
  lockedTitleTrial: "Your free trial has ended",
  lockedSubtitleOwner: "Choose a plan to unlock your account. You only pay once you add a card and choose a plan.",
  lockedSubtitleNonOwner: "Please contact your account owner to choose a plan.",
  lockedDeleteNote: (date) => `Your data is kept until ${date} unless you subscribe.`,

  // locked / payment problem for accounts without a trial (unchanged from before)
  cancelledTitle: "Your subscription has been cancelled",
  problemTitle: "Your subscription has some problems",
  contactManager: "Please contact your account manager to continue",

  // subscription page
  trialEndsOn: (date) => `Your free trial runs until ${date}.`,
  trialEndedOn: (date) => `Your free trial ended on ${date}.`,
}
